import {mapActions} from 'vuex';
import * as USER from '@/store/constants/user';
import {USER_ROLE} from "@/router/constant";

import Notification from '@/views/Common/Notification';

export default {
  name: 'Login',
  data() {
    return {
      user: {},
      notification: {
        show: false
      }
    }
  },

  components: {
    Notification
  },

  methods: {
    ...mapActions({
      authenticate: USER.AUTHENTICATE
    }),

    onReset() {

    },

    onSubmit() {
      this.authenticate(this.user).then(res => {
        const user = res.data;
        if (user.role.name === USER_ROLE.ADMIN) {
          this.$router.push({
            name: 'UserList'
          })
        } else {
          this.$router.push({
            name: 'DashboardMain'
          })
        }
      }).catch(err => {
        //  return false;
        console.log(err);
        let message = (err.response.data || {}).message || {};

        this.notification = {
          show: true,
          message: message,
          variant: 'danger'
        };
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/Login/js/login.js